import type { CellContext } from '@tanstack/react-table'
import React from 'react'

import type { Track } from 'types/track'

import { Text } from 'components/ds'

type Props = { info: CellContext<Track, unknown> }

// Intentionally blank until the backend endpoint returning the playlist
// appearance count is available. Keep the cell rendered so the column still
// participates in sizing/resizing.
const AppearsOnColumnInternal = (_props: Props) => {
  return <Text data-testid="appears-on-cell" />
}

export const AppearsOnColumn = React.memo(AppearsOnColumnInternal)

AppearsOnColumn.displayName = 'AppearsOnColumn'
